import { AGENTS } from './constants';
import { de } from './format';
function fmt(v, digits) {
    return digits ? de(v, digits) : String(Math.round(v));
}
function row(g, key, label, min, max, step, digits, unit, color) {
    return {
        key, label, min, max, step, digits, unit, color,
        hint: `${fmt(min, digits)} – ${fmt(max, digits)}${unit ? ` ${unit}` : ''}`,
        value: `${fmt(g[key], digits)}${unit ? ` ${unit}` : ''}`
    };
}
export function buildSettingGroups(g) {
    return [
        {
            title: 'pH-Sollwert',
            rows: [
                row(g, 'phMin', 'Minimum', 6, g.phMax - 0.1, 0.1, 1, '', 'var(--ph-color)'),
                row(g, 'phMax', 'Maximum', g.phMin + 0.1, 8.5, 0.1, 1, '', 'var(--ph-color)')
            ]
        },
        {
            title: 'Chlor-Sollwert mg/l',
            rows: [
                row(g, 'clMin', 'Minimum', 0, g.clMax - 0.05, 0.05, 2, '', 'var(--cl-color)'),
                row(g, 'clMax', 'Maximum', g.clMin + 0.05, 3, 0.05, 2, '', 'var(--cl-color)')
            ]
        },
        {
            title: 'Alkalinität ppm',
            rows: [
                row(g, 'taMin', 'Minimum', 0, g.taMax - 5, 5, 0, '', 'var(--ta-color)'),
                row(g, 'taMax', 'Maximum', g.taMin + 5, 300, 5, 0, '', 'var(--ta-color)')
            ]
        },
        {
            title: 'pH-Minus',
            rows: [
                row(g, 'phMinusDose', 'Gramm pro Dosis', 5, 2000, 5, 0, 'g', AGENTS.phMinus.color),
                row(g, 'phMinusEffect', 'pH-Änderung pro Dosis', 0.05, 1, 0.05, 2, '', AGENTS.phMinus.color)
            ]
        },
        {
            title: 'pH-Plus',
            rows: [
                row(g, 'phPlusDose', 'Gramm pro Dosis', 5, 2000, 5, 0, 'g', AGENTS.phPlus.color),
                row(g, 'phPlusEffect', 'pH-Änderung pro Dosis', 0.05, 1, 0.05, 2, '', AGENTS.phPlus.color)
            ]
        },
        {
            title: 'Chlor',
            rows: [
                row(g, 'clDose', 'Gramm pro Dosis', 5, 2000, 5, 0, 'g', AGENTS.chlor.color),
                row(g, 'clEffect', 'mg/l pro Dosis', 0.05, 1, 0.05, 2, '', AGENTS.chlor.color)
            ]
        },
        {
            title: 'Intervalle',
            rows: [
                row(g, 'filterDays', 'Filterwechsel', 1, 180, 1, 0, 'Tage', 'var(--interval-color)'),
                row(g, 'robotDays', 'Robi-Lauf', 1, 60, 1, 0, 'Tage', 'var(--interval-color)'),
                row(g, 'taDays', 'Alkalinität messen', 1, 90, 1, 0, 'Tage', 'var(--ta-color)')
            ]
        }
    ];
}
